module.exports = __webpack_public_path__ + "static/media/dining-room.14607877.mp3";